import { ICSModal } from "../../components";
import './ServerInfo.css'
import ServerInfoBody from "./ServerInfoBody";
import { LoadIndicator } from "devextreme-react";
import { useSelector } from "react-redux";
import { DefaultState } from "../../types";

interface ServerInfoProps {
    visible: boolean
    onHiding: () => void
}

const ServerInfo = ({visible, onHiding}: ServerInfoProps) => {
    const server = useSelector((state: DefaultState) => state.server)
    if(server.error){
        return <div>{server.error}</div>
      } else if(server.loading) {
        return <LoadIndicator />
      } else {
        return (
        <ICSModal visible={visible} onHiding={onHiding} title='Server Host Information' id='server_info' position='center' closeOnOutsideClick={true} defaultWidth='80vw' data-testid="server_info_test">
            <ServerInfoBody />
        </ICSModal>
    )
    }
}

export default ServerInfo